export const states = [
  'Albacete',
  'Alto Paraguay',
  'Alto Paraná',
  'Amambay',
  'Amazonas',
  'Anzoátegui',
  'Aragua',
  'Bahia',
  'Bolivar',
  'Boquerón',
  'Caaguazú',
  'Caazapá',
  'California',
  'Campo Elías',
  'Canindeyú',
  'Carabobo',
  'Central',
  'Concepción',
  'Cordillera',
  'Cuba',
  'Cundinamarca',
  'Districto Federal',
  'Distrito de Mumbai',
  'Durazno',
  'España',
  'Falcón',
  'Formosa',
  'Gauteng',
  'Goiás',
  'Guainía',
  'Guairá',
  'Guárico',
  'Guatemala',
  'Gush Dan',
  'Ibaraki',
  'Itapúa',
  'Ituzaingó',
  'Lara',
  'Mato Grosso ',
  'Mato Grosso do Sul',
  'Melo',
  'Mérida',
  'Meta',
  'Minas Gerais',
  'Misiones',
  'Monagas​',
  'Ñeembucú',
  'No informado',
  'Norte de Santander',
  'Nueva Esparta',
  'Pará',
  'Paraguarí',
  'Paraíba',
  'Paraná',
  'Pernambuco',
  'Piauí',
  'Presidente Hayes',
  'Provença Alpes Costa Azul',
  'Recuay',
  'Região de Tarapacá',
  'Rio de Janeiro',
  'Rio Grande do Sul',
  'San Felipe',
  'San Pedro',
  'Santa Catarina',
  'Santa Cruz',
  'Santa Fé',
  'Santander',
  'Santiago de Cuba',
  'São Paulo',
  'Sucre',
  'Táchira',
  'Tennessee',
  'Valparaiso',
  'Yaracuy',
  'Zulia',
]
